import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { ReportServices } from "../services/ReportServices";
import CustomPagination from "../utils/paginationUtils";
import SearchIcon from "../assets/searchIcon.svg";
import EditIcon from "../assets/editIcon.svg";
import "./CaseStageTimeColorInfo.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import EditTimeColorInfo from "./EditTimeColorInfo";
const CaseStageTimeColorIfo = () => {
  const [stageIdPairData, setStageIdPairData] = useState(null);
  const [stageColorData, setStageColorData] = useState(null);
  const [colorData, setColorData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [selectedStage, setSelectedStage] = useState(null);
  const searchTimeRef = useRef();
  const limit = 10;
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const getStageTimeColor = async () => {
    setLoading(true);
    try {
      const res = await ReportServices.getRawStatusTimeColor(
        page,
        limit,
        searchKey
      );
      setColorData(res?.data?.data);
      setTotalPages(res?.data?.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getStageTimeColor();
  }, [searchKey, page]);

  console.log("color data:", colorData);
  return (
    <div className="case-stages-color-box ">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp;Case Stages Time Color Info
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">
          Case Stages Time Color Info{" "}
          <span className="text-sm"> ( All the units are in Minute)</span>
        </div>
        <div className="flex gap-2 items-center">
          <div
            style={{ border: "1px solid #E4E4E4" }}
            className="flex items-center gap-2 bg-white rounded-[8px] px-4 py-[6px] "
          >
            <img src={SearchIcon} alt="search-icon" />
            <input
              type="text"
              placeholder="Search anything"
              style={{ border: "0" }}
              className="outline-none"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>{" "}
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      {loading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          {" "}
          <div
            className={`flex justify-between items-center  text-[#191919] font-semibold text-[18px] px-8 mb-4`}
          >
            <div className="w-[30%]">Case Stage Name</div>
            <div className="w-[70%] grid grid-cols-4  text-center">
              <div>On Track</div>
              <div>Delays</div>
              <div>Challenges</div>
              <div>Critical</div>
            </div>
          </div>
          <div>
            {colorData ? (
              colorData?.map((stage, idx) => {
                return (
                  <div
                    key={idx}
                    className={` py-6 px-8 rounded-[16px] ${
                      idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                    }`}
                  >
                    <div className="flex justify-between items-center ">
                      <div className="w-[30%]">
                        {stage?.commandCenterStageStatus}
                      </div>
                      <div className="w-[70%] text-sm grid grid-cols-4">
                        {stage?.records?.map((color, index) => {
                          return (
                            <div
                              className={`flex justify-center  items-center gap-2 ${
                                index % 2 === 0
                                  ? "hover:bg-[#f5f5f5] py-2"
                                  : "hover:bg-[white] py-2"
                              } cursor-pointer`}
                              onClick={() => setSelectedStage(stage)}
                            >
                              <div>
                                {" "}
                                <div className="font-medium">Time Limit</div>
                                <div
                                  style={{
                                    color: color?.textColor,
                                    backgroundColor: color?.bgColor,
                                  }}
                                  className=" text-center mt-1"
                                >
                                  {" "}
                                  {color?.minTimeLimit || "--"}
                                </div>
                              </div>
                              <div>
                                {" "}
                                <div className="font-medium">Start Time</div>
                                <div
                                  style={{
                                    color: color?.textColor,
                                    backgroundColor: color?.bgColor,
                                  }}
                                  className=" text-center mt-1"
                                >
                                  {" "}
                                  {color?.startTime || "--"}
                                </div>
                              </div>
                              <div>
                                {" "}
                                <div className="font-medium">End Time</div>
                                <div
                                  style={{
                                    color: color?.textColor,
                                    backgroundColor: color?.bgColor,
                                  }}
                                  className=" text-center mt-1"
                                >
                                  {color?.endTime || "--"}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
      <div className="flex justify-center mt-4">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
      {selectedStage && (
        <EditTimeColorInfo
          selectedStage={selectedStage}
          stageIdPairData={stageIdPairData}
          stageColorData={stageColorData}
          getStageTimeColor={getStageTimeColor}
          setOpen={setSelectedStage}
        />
      )}
    </div>
  );
};

export default CaseStageTimeColorIfo;
